// 外部ライブラリ等のimportと実行
import Rails from 'rails-ujs'
Rails.start()
// eslint-disable-next-line no-unused-vars
import _ from 'lodash'

// 自作のJS/css/imageの読み込み
import Kitty from 'src/js/application'
import 'src/stylesheets/application'
require.context('src/images/', true)

// 自作JSの実行
Kitty.start()
